import "../css/Footer.css";

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer--ctn">
                <p>Copyright © 2023</p>
                <p>Thank you :)</p>
            </div>
        </div>
    );
}

export default Footer;
